import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'

import {} from './util/auth';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    auth_token: '',
    display_name: '',
    image_url: '',
    frontend_faces: [],
    min_face_height: 0,
    domain_uuid: null,
  },
  getters: {
    authToken(state) {
      return state.auth_token;
    },
    displayName(state) {
      return state.display_name;
    },
    isLoggedIn(state) {
      return !!state.auth_token;
    },
    frontendFaces(state) {
      return state.frontend_faces;
    },
    domainUUID(state) {
      return state.domain_uuid;
    },
    minFaceHeight(state) {
      return state.min_face_height;
    }
  },
  mutations: {
    handleOauthLoginResponse(state, data) {
      if (!data.ok) {
        return console.log("Response not OK.");
      }
      const token = data.auth.token;
      const display_name = data.display_name || (data.user.tenant_info ? data.user.tenant_info.name : '');
      state.auth_token = token;
      state.display_name = display_name;
    },
    logout(state) {
      state.auth_token = '';
      state.display_name = '';
    },
    saveFrontendFaces(state, faces) {
      state.frontend_faces = faces;
    },
    setMinFaceHeight(state, min_face_height) {
      state.min_face_height = min_face_height;
    },
    setDomainUUID(state, domain_uuid) {
      state.domain_uuid = domain_uuid;
    }
  },
  // actions: {
  //   oauthLogin(oauth_id, oauth_provider) {

  //   }
  // },
  plugins: [createPersistedState()]
});



// WEBPACK FOOTER //
// ./src/store.js